import React from "react"
import {
  Button,
  FormGroup,
} from 'reactstrap'
import Webcam from "react-webcam"

const CameraCapture = (props) => {
  const { onCapture, } = props

  const webcamRef = React.useRef(null)
  const [imgSrc, setImgSrc] = React.useState(null)

  const _captureImage = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot()
    onCapture(imageSrc)
    setImgSrc(imageSrc)
  }, [webcamRef, onCapture, setImgSrc])

  const _resetImage = () => {
    onCapture(null)
    setImgSrc(null)
  }

  return (
    <>
      <FormGroup className="text-center">
        {imgSrc ? (
          <>
            <div>
              <img src={imgSrc} alt="Capture" />
            </div>
            <Button type="button" color="danger" className="btn-webcam-capture" onClick={_resetImage}>
              <i className="fa fa-undo fa-2x" style={{ margin: 'unset', width: 'unset', }} aria-hidden="true" />
            </Button>
          </>
        ) : (
          <>
            <div>
              <Webcam audio={false} ref={webcamRef} screenshotFormat="image/jpeg" width={props.width || 350} />
            </div>
            <Button type="button" color="primary" className="btn-webcam-capture mt-1" onClick={_captureImage}>
              <i className="fa fa-camera fa-2x" style={{ margin: 'unset', width: 'unset', }} aria-hidden="true" />
            </Button>
          </>
        )}
      </FormGroup>
    </>
  )
}

export default CameraCapture